import { PageNotFound } from '@mvf/product-components';
import { FunctionComponent } from 'react';
import { useOtherPagesStyles } from './useOtherPagesStyles';
import { useLocation } from 'react-router';

const isLinkShieldMicroFrontEnd = /^\/frontend\/link-shield.*/;

export const OtherPages: FunctionComponent = () => {
  const {} = useLocation();

  if (isLinkShieldMicroFrontEnd.test(location.pathname)) {
    return (
      <div style={useOtherPagesStyles().container}>
        <PageNotFound />
      </div>
    );
  }

  // Path points to a different frontend, do a full page reload
  window.location.pathname = location.pathname;
  return null;
};
